import React, { useState, useEffect } from 'react';
import githubService from '../utils/githubService';
import UserSettingsModal from './UserSettingsModal';

const Header = () => {
  const [githubUser, setGithubUser] = useState(null);
  const [showUserSettingsModal, setShowUserSettingsModal] = useState(false);
  const [userSettings, setUserSettings] = useState({
    defaultSchoolLevel: '',
    defaultGrade: '',
    defaultSheetUrl: ''
  });

  // GitHub 로그인 상태 확인 및 사용자 설정 로드
  useEffect(() => {
    const checkGitHubLogin = async () => {
      const token = localStorage.getItem('github_access_token');
      if (token) {
        try {
          const userInfo = await githubService.initializeWithToken(token);
          setGithubUser(userInfo);
          console.log('✅ GitHub 로그인 상태 확인 (Header):', userInfo.login);
        } catch (error) {
          console.log('❌ GitHub 토큰이 유효하지 않음 (Header):', error);
          localStorage.removeItem('github_access_token');
        }
      }
    };

    // 저장된 사용자 설정 로드
    const loadUserSettings = () => {
      const savedSettings = localStorage.getItem('user_default_settings');
      if (savedSettings) {
        try {
          const parsedSettings = JSON.parse(savedSettings);
          setUserSettings(parsedSettings);
          console.log('✅ 사용자 설정 로드됨 (Header):', parsedSettings);
        } catch (error) {
          console.error('❌ 사용자 설정 로드 실패 (Header):', error);
        }
      }
    };

    checkGitHubLogin();
    loadUserSettings();
  }, []);

  // GitHub 로그인 시작
  const handleGitHubLogin = () => {
    // 현재 페이지 URL을 저장
    localStorage.setItem('github_redirect_url', window.location.href);
    const authUrl = githubService.getAuthUrl();
    window.location.href = authUrl;
  };

  // GitHub 로그아웃
  const handleGitHubLogout = () => {
    githubService.logout();
    setGithubUser(null);
  };

  // 사용자 설정 저장
  const handleSaveUserSettings = (newSettings) => {
    try {
      localStorage.setItem('user_default_settings', JSON.stringify(newSettings));
      setUserSettings(newSettings);
      console.log('✅ 사용자 설정 저장됨 (Header):', newSettings);
      alert('설정이 저장되었습니다! 이제 템플릿 생성시 기본값으로 적용됩니다.');
    } catch (error) {
      console.error('❌ 사용자 설정 저장 실패 (Header):', error);
      alert('설정 저장 중 오류가 발생했습니다.');
    }
  };

  return (
    <>
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-blue-100">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <h1 className="text-2xl font-bold text-blue-800"><a href="/">English Study</a></h1>
            <div className="flex items-center space-x-4">
              {githubUser ? (
                <div className="relative group">
                  <div className="flex items-center space-x-2 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-50 transition-colors">
                    <img 
                      src={githubUser.avatar_url} 
                      alt={githubUser.login}
                      className="w-8 h-8 rounded-full"
                    />
                    <span className="text-gray-700 font-medium">{githubUser.login}</span>
                    <svg className="w-4 h-4 text-gray-500 transform group-hover:rotate-180 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                  
                  {/* 드롭다운 메뉴 */}
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                    <div className="py-2">
                      <button 
                        onClick={() => setShowUserSettingsModal(true)}
                        className="w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors flex items-center space-x-2"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <span>내 정보 기억하기</span>
                      </button>
                      <hr className="my-1 border-gray-200" />
                      <button 
                        onClick={handleGitHubLogout}
                        className="w-full text-left px-4 py-2 text-red-600 hover:bg-red-50 transition-colors flex items-center space-x-2"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                        </svg>
                        <span>로그아웃</span>
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <button 
                  onClick={handleGitHubLogin}
                  className="bg-gray-800 hover:bg-gray-900 text-white px-6 py-2 rounded-lg font-medium transition-colors duration-200 shadow-md hover:shadow-lg flex items-center space-x-2"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" />
                  </svg>
                  <span>GitHub 로그인</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* 사용자 설정 모달 */}
      <UserSettingsModal
        isOpen={showUserSettingsModal}
        onClose={() => setShowUserSettingsModal(false)}
        settings={userSettings}
        onSave={handleSaveUserSettings}
      />
    </>
  );
};

export default Header;